/*
 * @Author: Dong
 * @Date: 2022-05-05 17:07:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-30 16:29:06
 */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button, Switch, message } from 'sup-ui';
import Modal from 'root/components/CommonModal';
import AlarmConfig from 'root/components/MonitorManage/AlarmConfig';
import ViewLog from 'root/components/MonitorManage/ViewLog';
import RealTimeLog from 'root/components/MonitorManage/RealTimeLog';
import SourceConfigModal from 'root/components/MonitorManage/SourceConfigModal';
import FormSearch from 'root/components/MonitorManage/FormSearch';
import SupTable from 'sup-rc-table';
import {
  queryList,
  getNamespace,
  stopServices,
  startServices,
  reStartServices,
  getSourceConfig,
  saveSourceConfig,
  getApplicationList,
  getLogTree,
  getPodList,
} from 'root/services/serviceManage';
import { getAlarm, setAlarmConfigApi, editStatus } from 'root/services/alert';
import messages from './messages';
import styles from './index.less';
interface sourceConfigTypes {
  visible?: boolean;
  data?: any;
  params?: {
    namespace: string;
    serviceName: string;
    serviceType: string;
  };
}

interface alarmConfigTypes {
  visible?: boolean;
  data?: any;
  isJava?: boolean;
  params?: {
    namespace: string;
    podName: string;
  };
}

interface logModal {
  visible?: boolean;
  data?: any;
  params?: {
    namespace: string;
    podName: string;
  };
}

interface logConfig {
  visible?: boolean;
  data?: any;
  params?: {
    namespace: string;
    podName: string;
  };
}

let timer: any;

const { confirm } = Modal;

const contrastCondition: any = {
  name: {
    ascend: 'SERVICE_NAME_ASC',
    descend: 'SERVICE_NAME_DESC',
  },
  createTime: {
    ascend: 'CREATE_TIME_ASC',
    descend: 'CREATE_TIME_DESC',
  },

  cpuLimit: {
    ascend: 'CPU_LIMIT_ASC',
    descend: 'CPU_LIMIT_DESC',
  },
  cpuCurrent: {
    ascend: 'CPU_CURRENT_ASC',
    descend: 'CPU_CURRENT_DESC',
  },
  cpuUsage: {
    ascend: 'CPU_USAGE_ASC',
    descend: 'CPU_USAGE_DESC',
  },
  memLimit: {
    ascend: 'MEM_LIMIT_ASC',
    descend: 'MEM_LIMIT_DESC',
  },
  memCurrent: {
    ascend: 'MEM_CURRENT_ASC',
    descend: 'MEM_CURRENT_DESC',
  },
  memUsage: {
    ascend: 'MEM_USAGE_ASC',
    descend: 'MEM_USAGE_DESC',
  },
  storageLimit: {
    ascend: 'STORAGE_LIMIT_ASC',
    descend: 'STORAGE_LIMIT_DESC',
  },
  storageCurrent: {
    ascend: 'STORAGE_CURRENT_ASC',
    descend: 'STORAGE_CURRENT_DESC',
  },
  storageUsage: {
    ascend: 'STORAGE_USAGE_ASC',
    descend: 'STORAGE_USAGE_DESC',
  },
};

const statusRender: any = {
  STARTING: 'starting',
  RUNNING: 'runNing',
  STOPPED: 'stopped',
  STOPPING: 'stopping',
};

const ServiceManage = () => {
  const formSearchRef = useRef<any>();
  const sourceCongfigRef = useRef<any>();
  const alertCongfigRef = useRef<any>();
  const intl = useIntl();

  const [loading, setLoading] = useState(true);
  const [nameSpaceList, setNameSpaceList] = useState<any>([]); // 命名空间select
  const [applicationList, setApplicationList] = useState<any>([]); // 所属应用select

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  const [selectedRows, setSelectedRows] = useState<any[]>([]); // 选中项
  const [serviceCount, setServiceCount] = useState<{ totalService: number; runningService: number }>(); // 服务数
  const [tableData, setTableData] = useState<any>([]);

  const searchRef = useRef<any>({ page: 1, pageSize: 20, namespace: '', sortCondition: '', application: '' }); // 搜索条件
  const [searchParams, setSearchParams] = useState({
    page: 1,
    pageSize: 20,
    namespace: 'default',
    sortCondition: '',
    application: '',
  });
  const [sourceConfig, setSourceConfig] = useState<sourceConfigTypes>({}); // 资源配置
  const [alarmConfig, setAlarmConfig] = useState<alarmConfigTypes>({}); // 告警配置
  const [logModal, setLogModal] = useState<logModal>({}); // 查看日志;
  const [realTimeLog, setRealTimeLog] = useState<logConfig>({}); // 实时日志;

  const [columns, setColumns] = useState<any[]>([]); // 表头数据
  const [sortedInfo, setSortedInfo] = useState<{ columnKey?: string; order?: string }>({}); // 排序字段

  useEffect(() => {
    setLogModal({
      visible: false,
      data: [],
    });
  }, []);

  useEffect(() => {
    setColumns([
      {
        title: intl.formatMessage(messages.serviceName),
        width: 200,
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        align: 'left',
      },

      {
        title: intl.formatMessage(messages.status),
        width: 180,
        dataIndex: 'status',
        align: 'left',
        key: 'status',
        render: (text: string, record: any) => {
          const name = statusRender[text];
          return (
            <>
              <span className={styles[name]}>{intl.formatMessage(messages[name])}</span>
              &nbsp;
              <span className={styles[name]}>
                ({record.readyReplicas}/{record.replicas})
              </span>
            </>
          );
        },
      },
      {
        title: intl.formatMessage(messages.application),
        width: 200,
        dataIndex: 'application',
        key: 'application',
        align: 'left',
        render: (text: string) => (text === 'unknown' ? '-' : text),
      },
      {
        title: intl.formatMessage(messages.field),
        width: 200,
        dataIndex: 'domain',
        key: 'domain',
        align: 'left',
        render: (text: string) => (text === 'unknown' ? '-' : text),
      },

      {
        title: intl.formatMessage(messages.namespace),
        width: 120,
        dataIndex: 'namespace',
        align: 'left',
        key: 'namespace',
      },
      {
        title: intl.formatMessage(messages.startTime),
        width: 180,
        align: 'left',
        dataIndex: 'createTime',
        key: 'createTime',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'createTime' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text);
        },
      },
      {
        title: intl.formatMessage(messages.cpuLimit),
        width: 120,
        align: 'center',
        dataIndex: 'cpuLimit',
        key: 'cpuLimit',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'cpuLimit' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text);
        },
      },
      {
        title: intl.formatMessage(messages.cpuCurrent),
        width: 120,
        align: 'center',
        dataIndex: 'cpuCurrent',
        key: 'cpuCurrent',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'cpuCurrent' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text);
        },
      },
      {
        title: intl.formatMessage(messages.cpuUsage),
        width: 120,
        align: 'center',
        dataIndex: 'cpuUsage',
        key: 'cpuUsage',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'cpuUsage' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, '%');
        },
      },
      {
        title: intl.formatMessage(messages.memLimit),
        width: 120,
        align: 'center',
        dataIndex: 'memLimit',
        key: 'memLimit',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'memLimit' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, 'GB');
        },
      },
      {
        title: intl.formatMessage(messages.memCurrent),
        width: 120,
        align: 'center',
        dataIndex: 'memCurrent',
        key: 'memCurrent',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'memCurrent' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, 'GB');
        },
      },
      {
        title: intl.formatMessage(messages.memUsage),
        width: 120,
        align: 'center',
        dataIndex: 'memUsage',
        key: 'memUsage',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'memUsage' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, '%');
        },
      },
      {
        title: intl.formatMessage(messages.storageLimit),
        width: 120,
        align: 'center',
        dataIndex: 'storageLimit',
        key: 'storageLimit',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'storageLimit' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, 'GB');
        },
      },
      {
        title: intl.formatMessage(messages.storageCurrent),
        width: 120,
        align: 'center',
        dataIndex: 'storageCurrent',
        key: 'storageCurrent',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'storageCurrent' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, 'GB');
        },
      },
      {
        title: intl.formatMessage(messages.storageUsage),
        width: 120,
        align: 'center',
        dataIndex: 'storageUsage',
        key: 'storageUsage',
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'storageUsage' && sortedInfo.order,
        render: (text: any) => {
          return transNum(text, '%');
        },
      },
      {
        title: intl.formatMessage(messages.alertEnabled),
        width: 120,
        align: 'center',
        dataIndex: 'alertEnabled',
        key: 'alertEnabled',
        render: (checked: boolean, record: any) => {
          return (
            <div>
              <Switch
                checked={checked}
                defaultChecked={checked}
                disabled={['STARTING', 'STOPPING'].includes(record.status)}
                size="small"
                onClick={() => {
                  changeSwitch(record);
                }}
              />
            </div>
          );
        },
      },
      {
        title: intl.formatMessage(messages.action),
        dataIndex: 'operation',
        type: 'operation',
        fixed: true,
        width: 350,
        render: (text: any, record: any) => {
          const btnDisabled = ['STARTING', 'STOPPING'].includes(record.status);
          return (
            <div className={styles.btnGroup}>
              {record.status === 'STOPPED' ? (
                <Button
                  type="link"
                  disabled={btnDisabled}
                  onClick={() => {
                    handleRestart(record, 'start');
                  }}
                >
                  {intl.formatMessage(messages.start)}
                </Button>
              ) : null}
              <Button
                type="link"
                disabled={btnDisabled}
                onClick={() => {
                  handleRestart(record);
                }}
              >
                {intl.formatMessage(messages.restart)}
              </Button>

              {record.status !== 'STOPPED' ? (
                <Button
                  type="link"
                  disabled={btnDisabled}
                  onClick={() => {
                    handleStop(record);
                  }}
                >
                  {intl.formatMessage(messages.stop)}
                </Button>
              ) : null}

              <Button
                type="link"
                disabled={btnDisabled}
                onClick={() => {
                  toggleVisibleSourceConfig(record);
                }}
              >
                {intl.formatMessage(messages.resourceAllocation)}
              </Button>
              <Button
                type="link"
                disabled={btnDisabled}
                onClick={() => {
                  toggleVisibleAlarmConfig(record);
                }}
              >
                {intl.formatMessage(messages.alarmSetting)}
              </Button>
              <Button
                type="link"
                onClick={() => {
                  toggleVisibleLogModal(record);
                }}
              >
                {intl.formatMessage(messages.viewLog)}
              </Button>
              <Button
                type="link"
                onClick={() => {
                  toggleVisibleLogConfig(record);
                }}
              >
                {intl.formatMessage(messages.realTimeLog)}
              </Button>
            </div>
          );
        },
      },
    ]);
  }, [sortedInfo]);

  useEffect(() => {
    // 命名空间必传，所有先获取命名空间请求
    getNamespace().then((res) => {
      const { data = [] } = res;
      setNameSpaceList(data);
      setSearchParams({
        ...searchParams,
        namespace: data[0],
      });
      formSearchRef.current?.setFieldsValue({ namespace: data[0] });
    });
  }, []);

  useEffect(() => {
    searchRef.current = searchParams;
    if (searchRef.current.application === intl.formatMessage(messages.all)) searchRef.current.application = '';
    if (!searchParams.namespace) return;
    getData();
  }, [searchParams]);

  // 获取资源配置数据
  useEffect(() => {
    if (!sourceConfig.visible) return;
    getSourceConfigData();
  }, [sourceConfig.visible]);

  // 获取告警配置数据
  useEffect(() => {
    if (!alarmConfig.visible) return;
    getAlarmConfigData();
  }, [alarmConfig.visible]);
  // 切换页面时清除定时器
  useEffect(() => {
    return () => {
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  // 获取所属应用列表信息
  useEffect(() => {
    getApplicationList().then((res) => {
      const { data = [] } = res;
      data.unshift(intl.formatMessage(messages.all));
      setApplicationList(data);
      setSearchParams({
        ...searchParams,
        application: data[0],
      });
      formSearchRef.current?.setFieldsValue({ application: data[0] });
    });
  }, []);

  // 多选操作的按钮状态
  const btnDisabled = useMemo(() => {
    return selectedRows.length === 0;
  }, [selectedRows]);

  // 告警开启下拉
  const alertEnabledList = useMemo(() => {
    return [
      {
        name: intl.formatMessage(messages.all),
        value: '',
      },
      {
        name: intl.formatMessage(messages.open),
        value: 'true',
      },
      {
        name: intl.formatMessage(messages.close),
        value: 'false',
      },
    ];
  }, []);

  // 状态下拉选项写死  命名空间需要先获取
  // STARTING, RUNNING, STOPPING, STOPPED 后端提供
  const statusList = useMemo(() => {
    return [
      {
        name: intl.formatMessage(messages.all),
        value: '',
      },
      {
        name: intl.formatMessage(messages.runNing),
        value: 'RUNNING',
      },
      {
        name: intl.formatMessage(messages.stopping),
        value: 'STOPPING',
      },
      {
        name: intl.formatMessage(messages.pending),
        value: 'STARTING',
      },
      {
        name: intl.formatMessage(messages.stopped),
        value: 'STOPPED',
      },
    ];
  }, []);

  // 选中项
  const selectedRowKeys = useMemo(() => {
    return selectedRows.map((item) => {
      return item.name;
    });
  }, [selectedRows]);

  const loop = () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      getData();
    }, 10000);
  };

  // 获取列表数据
  const getData = () => {
    queryList({ ...searchRef.current })
      .then((res) => {
        const { serviceDTOS, currentPage, pageSize, totalSize, totalService, runningService } = res.data;
        setTableData(serviceDTOS);
        setServiceCount({ totalService, runningService });
        setPagination({
          current: currentPage,
          pageSize: pageSize,
          total: totalSize,
        });
        loop();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取资源配置信息
  const getSourceConfigData = () => {
    const params = { ...sourceConfig?.params };
    getSourceConfig(params).then((res: any) => {
      const { initContainers, containers } = res.data;

      setSourceConfig({
        ...sourceConfig,
        data: { initContainers, containers },
      });
    });
  };

  // 获取告警阈值信息
  const getAlarmConfigData = () => {
    const params = { ...alarmConfig?.params };
    getAlarm(params).then((res: any) => {
      const { data = [] } = res.data;
      const { cpuLimit, cpuTime, memLimit, memoryLimit, memoryTime, diskLimit, diskTime, jvmLimit, jvmTime } =
        data[0] || {};

      setAlarmConfig({
        ...alarmConfig,
        data: { cpuLimit, cpuTime, memLimit, memoryLimit, memoryTime, diskLimit, diskTime, jvmLimit, jvmTime },
      });
    });
  };

  // 点击查询
  const handleSubmit = (e: any) => {
    e.preventDefault();

    formSearchRef.current?.validateFields((err: any, values: any) => {
      setLoading(true);
      setSortedInfo({});
      setSelectedRows([]);
      setSearchParams({
        ...searchParams,
        ...values,
        page: 1,
        sortCondition: '',
      });
    });
  };

  // 点击重置
  const clearForm = () => {
    formSearchRef.current?.resetFields();
    setLoading(true);
    setSortedInfo({});
    setSelectedRows([]);
    formSearchRef.current?.setFieldsValue({ namespace: nameSpaceList[0] });
    formSearchRef.current?.setFieldsValue({ application: applicationList[0] });
    setSearchParams({
      page: 1,
      pageSize: 20,
      namespace: nameSpaceList[0],
      sortCondition: '',
      application: '',
    });
  };
  // 修改告警状态
  const changeStatus = (podName: any, namespace: any, status: Number) => {
    editStatus({
      podName,
      namespace,
      status,
      podIp: '',
    }).then(() => {
      setLoading(true);
      getData();
    });
  };
  const changeSwitch = (record: any) => {
    // 如果配置过告警设置  直接发请求开启或者关闭
    if (!record.alertConfig) {
      return toggleVisibleAlarmConfig(record);
    }
    // 如果没有配置过告警设置  需要先打开告警设置弹框进行配置
    if (record.alertEnabled) {
      confirm({
        content: intl.formatMessage(messages.closeServices),
        onOk: () => {
          changeStatus(record.name, record.namespace, 0);
        },
      });
      return;
    }

    changeStatus(record.name, record.namespace, 1);
  };

  const transNum = (num: any, unit?: string) => {
    if ([null, undefined].includes(num)) {
      return '-';
    }
    const str = unit === 'GB' ? (num / 1024 / 1024 / 1024).toFixed(2) : num;
    return `${str}${unit || ''}`;
  };

  // 获取重启、停止操作的数据参数
  const getOptParams = (record?: any) => {
    let params: any[] = [];
    let namespace = '';

    // 区分单个和批量操作
    if (record) {
      namespace = record.namespace;

      params.push({ name: record.name, type: record.type });
    } else {
      namespace = selectedRows[0].namespace;
      params = selectedRows.map((item) => {
        return {
          name: item.name,
          type: item.type,
        };
      });
    }

    return { namespace, params };
  };
  // 启动
  const handleStart = (record?: any) => {
    const { namespace, params } = getOptParams(record);

    confirm({
      content: intl.formatMessage(messages.startServices),
      onOk: () => {
        startServices(namespace, params).then(() => {
          // 批量启动后，清空选中项
          if (!record) {
            setSelectedRows([]);
          }
          setLoading(true);
          getData();
        });
      },
    });
  };
  // 重启
  const handleRestart = (record?: any, type?: string) => {
    const { namespace, params } = getOptParams(record);

    confirm({
      content: intl.formatMessage(type === 'start' ? messages.startServices : messages.restartServices),
      onOk: () => {
        reStartServices(namespace, params).then(() => {
          // 批量重启后，清空选中项
          if (!record) {
            setSelectedRows([]);
          }
          setLoading(true);
          getData();
        });
      },
    });
  };

  // 停止
  const handleStop = (record?: any) => {
    const { namespace, params } = getOptParams(record);

    confirm({
      content: intl.formatMessage(messages.stopServices),
      onOk: () => {
        stopServices(namespace, params).then(() => {
          // 批量重启后，清空选中项
          if (!record) {
            setSelectedRows([]);
          }
          setLoading(true);
          getData();
        });
      },
    });
  };

  // 翻页、排序
  const handleSearch = (params: any, types: any) => {
    setLoading(true);
    // 翻页
    if (types === 'pagination') {
      setSelectedRows([]);
      return setSearchParams({
        ...searchParams,
        page: params?.pagination?.current,
        pageSize: params?.pagination?.pageSize,
      });
    }

    // 排序
    if (types === 'sorter') {
      const [key, value] = Object.entries(params.sorter)[0];
      const sort = key && value ? contrastCondition[key][value as string] : '';

      // 更新排序字段
      setSortedInfo({ columnKey: key, order: value as string });

      setSearchParams({
        ...searchParams,
        sortCondition: sort,
        page: 1,
      });
    }
  };

  // 选中项发生改变
  const handleChangeSelectItem = (selectedRowKeys: any, newSelectedRows: any[]) => {
    setSelectedRows(newSelectedRows);
  };

  // 显隐资源配置弹框
  const toggleVisibleSourceConfig = (record: any = {}) => {
    setSourceConfig({
      visible: !sourceConfig.visible,
      params: {
        namespace: record.namespace,
        serviceName: record.name,
        serviceType: record.type,
      },
    });
  };

  // 资源配置确认
  const handleOkSourceConfig = () => {
    const { params } = sourceConfig;

    sourceCongfigRef.current?.validateFields((err: any, values: any) => {
      if (err) return;

      const resource: { [x: string]: any } = {};
      Object.keys(values).forEach((item) => {
        const [type, key, unit, index] = item.split('-');
        const i = Number(index);

        if (!resource[type]) {
          resource[type] = [];
        }

        if (!resource[type][i]) {
          resource[type][i] = {};
        }

        // 带单位的参数
        if (unit) {
          resource[type][i][`${key}Amount`] = values[item];
          resource[type][i][`${key}Format`] = unit === 'vC' ? '' : unit;
        } else {
          // 其他参数
          resource[type][i][key] = values[item];
        }
      });

      const body = {
        ...params,
        ...resource,
      };

      confirm({
        content: intl.formatMessage(messages.sourceConfigTip),
        onOk: () => {
          saveSourceConfig(body).then(() => {
            message.success(intl.formatMessage(messages.success));
            toggleVisibleSourceConfig();
            getData();
          });
        },
      });
    });
  };

  // 显隐告警配置弹框
  const toggleVisibleAlarmConfig = (record: any = {}) => {
    setAlarmConfig({
      visible: !alarmConfig.visible,
      isJava: record.language === 'java',
      params: {
        namespace: record.namespace,
        podName: record.name,
      },
    });
  };

  // 下载日志按钮弹框
  const toggleVisibleLogModal = (record: any = {}) => {
    getLogTree(record.name).then((res) => {
      setLogModal({
        visible: true,
        data: res.data,
      });
    });
  };

  // 实时日志弹框
  const toggleVisibleLogConfig = (record: any = {}) => {
    getPodList(record.name).then((res) => {
      res.data.name = record.name;
      setRealTimeLog({ visible: true, data: res.data });
    });
  };

  // 告警配置确认
  const handleOkAlarmConfig = () => {
    const { params } = alarmConfig;

    alertCongfigRef.current?.form?.validateFields((err: any, values: any) => {
      if (err) return;
      const body = [
        {
          ...params,
          ...values,
        },
      ];
      setAlarmConfigApi(body).then(() => {
        message.success(intl.formatMessage(messages.success));
        toggleVisibleAlarmConfig();
        setLoading(true);
        getData();
      });
    });
  };

  const afterClose = () => {
    setLoading(true);
    getData();
  };
  // 判断checkbox是否可选
  const checkedCheckboxDisabled = (record: { status: string }) => {
    return { disabled: ['STARTING', 'STOPPING'].includes(record.status) };
  };

  // 更新columns
  const updateColumns = (newColumns: any) => {
    setColumns(newColumns);
  };

  const btnClickObject: { [x: string]: any } = {
    clearForm: clearForm,
    restart: handleRestart,
    stop: handleStop,
    start: handleStart,
  };

  const formBtnClick = (type: string) => {
    if (!type || !btnClickObject[type]) return;
    btnClickObject[type]();
  };

  return (
    <div className={styles.container}>
      <div className={styles.query}>
        <FormSearch
          ref={formSearchRef}
          statusOptions={statusList}
          namespaceOptions={nameSpaceList}
          alertEnabledOptions={alertEnabledList}
          applicationOptions={applicationList}
          btnDisabled={btnDisabled}
          onBtnClick={formBtnClick}
          onSubmit={handleSubmit}
        />
        <div className={styles.serviceAlready}>
          {serviceCount?.totalService && (
            <span>
              {intl.formatMessage(messages.serviceAlreadyRunning)}
              {serviceCount?.runningService}/{serviceCount?.totalService}&nbsp; &nbsp;
              {intl.formatMessage(messages.reFreshTime)}
            </span>
          )}
        </div>
      </div>

      <div className={styles.dataTable}>
        <SupTable
          controlColumns
          rowKey="name"
          loading={loading}
          updateColumns={updateColumns}
          pagination={pagination}
          onSearch={handleSearch}
          columns={columns}
          dataSource={tableData}
          showSearchIcon={false}
          showColumnsFilter={false}
          selectedRowKeys={selectedRowKeys}
          getCheckboxProps={checkedCheckboxDisabled}
          onSelectItem={handleChangeSelectItem}
        />
      </div>
      <SourceConfigModal
        ref={sourceCongfigRef}
        visible={sourceConfig?.visible}
        onOk={handleOkSourceConfig}
        onCancel={toggleVisibleSourceConfig}
        defaultData={sourceConfig?.data}
      />

      <AlarmConfig
        java={alarmConfig.isJava}
        wrappedComponentRef={alertCongfigRef}
        title={intl.formatMessage(messages.alarmSetting)}
        visible={alarmConfig?.visible}
        onOk={handleOkAlarmConfig}
        onCancel={toggleVisibleAlarmConfig}
        dataInfo={alarmConfig?.data || {}}
        afterClose={afterClose}
      />
      <ViewLog
        onOk={() => {
          setLogModal({ visible: false });
        }}
        onCancel={() => {
          setLogModal({ visible: false });
        }}
        visible={logModal.visible || false}
        data={logModal?.data}
      />
      <RealTimeLog
        onOk={() => {
          setRealTimeLog({ visible: false });
        }}
        onCancel={() => {
          setRealTimeLog({ visible: false });
        }}
        visible={realTimeLog.visible || false}
        data={realTimeLog.data}
      />
    </div>
  );
};

export default ServiceManage;
